import { Box, IconButton, Tooltip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { BlockClicks } from "lib/@components/block-clicks"
import { If } from "lib/@components/switch"
import { alert } from "lib/@dialogs/alert"
import Iconify from "minimals-template/components/Iconify"
import { RegimeDraftLockTooltip } from "routes/regime/regime-draft-locking/regime-draft-lock-tooltip"
import { useTaskShareLinkCommentReason } from "routes/schedule/plugins/share-link-comments/use-task-share-link-comment-reason"

export function JustifyTailoringButton() {
    const { task, tailoringAudit, setJustification, taskTailored, pendingChange, isEditable = true } = useBoundContext()
    const commentReason = useTaskShareLinkCommentReason()
    const tooltip = getTooltip()

    return (
        <Box width={36}>
            <If truthy={!task.isHeader && !tailoringAudit?.payload?.reason && isEditable}>
                <BlockClicks>
                    <RegimeDraftLockTooltip>
                        <Tooltip title={tooltip} componentsProps={{ tooltip: { "data-cy": "justification-tooltip" } }}>
                            <IconButton
                                aria-label="Add justification"
                                color="primary"
                                onClick={handleClick}
                                size="small"
                                sx={{ ml: 1 }}
                                data-cy="tailoring-justification-button"
                            >
                                <Iconify icon="iconoir:chat-plus-in" />
                            </IconButton>
                        </Tooltip>
                    </RegimeDraftLockTooltip>
                </BlockClicks>
            </If>
        </Box>
    )

    // When the task has share-link comments, the justification box is pre-filled from them; otherwise
    // it opens blank for a free-text justification.
    function getTooltip() {
        if (!taskTailored) return "Nothing to justify"
        if (commentReason) return "Pre-filled from the comment. Edit it or leave it as is"
        return "Add justification"
    }

    async function handleClick() {
        if (taskTailored) {
            if (pendingChange) {
                await alert(
                    "Please wait until schedule updates are saved before adding a justification.",
                    "Schedule Updating"
                )
            } else {
                setJustification({
                    reason: commentReason,
                })
            }
        } else {
            await alert(
                "To be able to leave a justification, you must first change something on the task.",
                "Make a change and leave a justification"
            )
        }
    }
}
